import EstimationNav from "components/v3/Estimation/navbar/EstimationNav";
import useTranslation from "next-translate/useTranslation";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import { selectors as EstimationSelectors } from "redux/slices/v2/EstimationReducer";
import style from "./Estimation.module.css";

const StepOne = dynamic(
  () => import("components/v3/Estimation/Steps/StepOne"),
  {
    suspense: false,
    ssr: false,
  }
);
const StepSeven = dynamic(
  () => import("components/v3/Estimation/Steps/StepSeven"),
  {
    suspense: false,
    ssr: false,
  }
);
const ResultPage = dynamic(
  () => import("components/v3/Estimation/ResultPage"),
  {
    suspense: false,
    ssr: false,
  }
);
const UpdatePage = dynamic(
  () => import("components/v3/Estimation/UpdatePage"),
  {
    suspense: false,
    ssr: false,
  }
);
const ErrorPage = dynamic(() => import("components/v3/Estimation/ErrorPage"), {
  suspense: false,
  ssr: false,
});
const LoginRegister = dynamic(
  () => import("components/v3/Estimation/LoginRegister"),
  {
    suspense: false,
    ssr: false,
  }
);
const BienContainer = dynamic(
  () => import("components/v3/Estimation/biens/bienContainer"),
  {
    suspense: false,
    ssr: false,
  }
);
function Estimation() {
  const activeStep = useSelector(EstimationSelectors.activeStepSelector);

  const { t, lang } = useTranslation("Estimation");

  return (
    <div className={style.container}>
      {activeStep < 10 && (
        <div className={style.navbar}>
          <EstimationNav t={t} activeStep={activeStep} />
        </div>
      )}

      {activeStep == 1 ? (
        <>
          <StepOne t={t} lang={lang} />
        </>
      ) : null}
      {activeStep == 0 ||
      activeStep == 2 ||
      activeStep == 3 ||
      activeStep == 4 ||
      activeStep == 5 ||
      activeStep == 6 ? (
        <BienContainer t={t} />
      ) : null}
      {activeStep == 7 ? <StepSeven t={t} /> : null}
      {activeStep == 8 || activeStep == 9 ? <LoginRegister t={t} /> : null}
      {activeStep == 10 ? <ResultPage t={t} lang={lang} /> : null}
      {activeStep == 11 ? <UpdatePage t={t} /> : null}
      {activeStep == "Error" ? <ErrorPage t={t} /> : null}
    </div>
  );
}

export default Estimation;
